import React from 'react';
import clsx from 'clsx';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md';
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}) => {
  const base =
    'inline-flex items-center justify-center rounded-md font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--color-primary-light)] disabled:opacity-60 disabled:cursor-not-allowed';
  const variantClass =
    variant === 'secondary'
      ? 'border border-[var(--color-gray-300)] text-[var(--color-gray-800)] bg-white hover:bg-[var(--color-gray-100)]'
      : variant === 'ghost'
      ? 'text-[var(--color-gray-700)] hover:bg-[var(--color-gray-100)]'
      : 'text-white bg-[var(--color-primary)] hover:bg-[var(--color-primary-light)]';
  const sizeClass =
    size === 'sm' ? 'px-3 py-1 text-sm' : 'px-4 py-2 text-md';

  return (
    <button
      className={clsx(base, variantClass, sizeClass, className)}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;

